import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import English translations
import enCommon from './locales/en/common.json';
import enNavigation from './locales/en/navigation.json';
import enAuth from './locales/en/auth.json';
import enDashboard from './locales/en/dashboard.json';
import enForms from './locales/en/forms.json';
import enDatabase from './locales/en/database.json';
import enQuestionDesign from './locales/en/questionDesign.json';
import enFormResponses from './locales/en/formResponses.json';
import enFormManagement from './locales/en/formManagement.json';
import enProcessManagement from './locales/en/processManagement.json';
import enGroupManagement from './locales/en/groupManagement.json';
import enOrganization from './locales/en/organization.json';
import enProfile from './locales/en/profile.json';
import enTable from './locales/en/table.json';
import enSettings from './locales/en/settings.json';
import enSidebar from './locales/en/sidebar.json';
import enQrCode from './locales/en/qrCode.json';
import enApplications from './locales/en/applications.json';
import enLanguage from './locales/en/language.json';
import enAnswerApplication from './locales/en/answerApplication.json';
import enApplicationResponse from './locales/en/applicationResponse.json';
import enDashboards from './locales/en/dashboards.json';
import enFolders from './locales/en/folders.json';
import enAuditLogs from './locales/en/auditLogs.json';
import enCertificate from './locales/en/certificate.json';
import enBackup from './locales/en/backup.json';
import enTemplates from './locales/en/templates.json';
import enDelegation from './locales/en/delegation.json';
import enProcessTriggers from './locales/en/processTriggers.json';

// Import French translations
import frCommon from './locales/fr/common.json';
import frNavigation from './locales/fr/navigation.json';
import frAuth from './locales/fr/auth.json';
import frDashboard from './locales/fr/dashboard.json';
import frForms from './locales/fr/forms.json';
import frDatabase from './locales/fr/database.json';
import frQuestionDesign from './locales/fr/questionDesign.json';
import frFormResponses from './locales/fr/formResponses.json';
import frFormManagement from './locales/fr/formManagement.json';
import frProcessManagement from './locales/fr/processManagement.json';
import frGroupManagement from './locales/fr/groupManagement.json';
import frOrganization from './locales/fr/organization.json';
import frProfile from './locales/fr/profile.json';
import frTable from './locales/fr/table.json';
import frSettings from './locales/fr/settings.json';
import frSidebar from './locales/fr/sidebar.json';
import frQrCode from './locales/fr/qrCode.json';
import frApplications from './locales/fr/applications.json';
import frLanguage from './locales/fr/language.json';
import frAnswerApplication from './locales/fr/answerApplication.json';
import frApplicationResponse from './locales/fr/applicationResponse.json';
import frDashboards from './locales/fr/dashboards.json';
import frFolders from './locales/fr/folders.json';
import frAuditLogs from './locales/fr/auditLogs.json';
import frCertificate from './locales/fr/certificate.json';
import frBackup from './locales/fr/backup.json';
import frTemplates from './locales/fr/templates.json';
import frDelegation from './locales/fr/delegation.json';
import frProcessTriggers from './locales/fr/processTriggers.json';

// Merge all translations into a single object
const enTranslations = {
  common: enCommon,
  navigation: enNavigation,
  auth: enAuth,
  dashboard: enDashboard,
  forms: enForms,
  database: enDatabase,
  questionDesign: enQuestionDesign,
  formResponses: enFormResponses,
  formManagement: enFormManagement,
  processManagement: enProcessManagement,
  groupManagement: enGroupManagement,
  organization: enOrganization,
  profile: enProfile,
  table: enTable,
  settings: enSettings,
  sidebar: enSidebar,
  qrCode: enQrCode,
  applications: enApplications,
  language: enLanguage,
  answerApplication: enAnswerApplication,
  applicationResponse: enApplicationResponse,
  dashboards: enDashboards,
  folders: enFolders,
  auditLogs: enAuditLogs,
  certificate: enCertificate,
  backup: enBackup,
  templates: enTemplates,
  delegation: enDelegation,
  processTriggers: enProcessTriggers,
};

const frTranslations = {
  common: frCommon,
  navigation: frNavigation,
  auth: frAuth,
  dashboard: frDashboard,
  forms: frForms,
  database: frDatabase,
  questionDesign: frQuestionDesign,
  formResponses: frFormResponses,
  formManagement: frFormManagement,
  processManagement: frProcessManagement,
  groupManagement: frGroupManagement,
  organization: frOrganization,
  profile: frProfile,
  table: frTable,
  settings: frSettings,
  sidebar: frSidebar,
  qrCode: frQrCode,
  applications: frApplications,
  language: frLanguage,
  answerApplication: frAnswerApplication,
  applicationResponse: frApplicationResponse,
  dashboards: frDashboards,
  folders: frFolders,
  auditLogs: frAuditLogs,
  certificate: frCertificate,
  backup: frBackup,
  templates: frTemplates,
  delegation: frDelegation,
  processTriggers: frProcessTriggers,
};

const resources = {
  en: {
    translation: enTranslations,
  },
  fr: {
    translation: frTranslations,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
